var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitigationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5005 24.9999V27.4999H2.50049V24.9999H17.5005ZM18.233 0.857422L27.9555 10.5799L26.188 12.3499L24.863 11.9074L21.7667 14.9999L28.838 22.0712L27.0705 23.8387L20.0005 16.7674L16.9955 19.7724L17.3492 21.1874L15.5805 22.9549L5.85799 13.2324L7.62674 11.4649L9.03924 11.8174L16.9067 3.95117L16.4655 2.62617L18.233 0.857422ZM19.1167 5.27742L10.278 14.1149L14.6967 18.5349L23.5355 9.69742L19.1167 5.27742Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitigationIcon);
export default __webpack_public_path__ + "static/media/LitigationIcon.4f41fa395c9b0e14eb964177de9a8463.svg";
export { ForwardRef as ReactComponent };